// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TfKz","expireSoon":"styles_expireSoon__dv7t-"};